import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-350px w-md-400px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Ayarlar")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Otomatik Değişiklikler:", -1)
const _hoisted_7 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid mb-2" }
const _hoisted_8 = { class: "form-check-label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label user-select-none" }, "Tıkladığımda en yüksek fiyata eşitle", -1)
const _hoisted_10 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_11 = { class: "form-check-label" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label user-select-none" }, "Fiyatlar aynı ise değişiklik yaptığımda tümünü değiştir", -1)
const _hoisted_13 = { class: "d-flex justify-content-end" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-sm btn-white btn-active-light-primary me-2",
  "data-kt-menu-dismiss": "true"
}, " Sıfırla ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              name: "notifications",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settingsCopy.changeToHighestPrice) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.settingsCopy.changeToHighestPrice]
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              name: "notifications",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingsCopy.changeAllIfEqual) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.settingsCopy.changeAllIfEqual]
            ]),
            _hoisted_12
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateParent && _ctx.updateParent(...args))),
          "data-kt-menu-dismiss": "true"
        }, " Uygula ")
      ])
    ])
  ]))
}